import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUndo, faUsers } from "@fortawesome/free-solid-svg-icons";
const token = localStorage.getItem('token');

const TrashCollaborators = () => {
  const [deletedCollaborators, setDeletedCollaborators] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDeletedCollaborators();
  }, []);

  const fetchDeletedCollaborators = async () => {
    try {
      const res = await axios.get(`/collaborator?withDeleted=true`, {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });
      const onlyDeleted = res.data.filter((p) => p.deletedAt != null);
      setDeletedCollaborators(onlyDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des collaborators supprimés", error);
    }
  };
  const handleRestore = async (id) => {
    try {
      await axios.patch(`/collaborator/recover/${id}`, null, {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      });

      setDeletedCollaborators((prev) => prev.filter((collaborator) => collaborator.id !== id));
    } catch (error) {
      console.error("Erreur lors de la restauration du collaborator", error);
    }
  };

  return (
    <div className="p-6">
    <div className="top-bar">
            <h3>Collaborateurs supprimés</h3>
          <div>
          <button onClick={() => navigate("/admin/collaborators")} className="bout-trash">
            <FontAwesomeIcon icon={faUsers} style={{ marginRight: "8px" }} /> 
            Liste des collaborateurs
          </button>
          </div></div>

      <table className="w-full border-collapse">
        <thead>
          <tr>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">E-mail</th>
              <th className="p-2 border">Poste</th>
              <th className="p-2 border">PositionJEI</th>
              <th className="p-2 border">Projets associés</th>
              <th className="p-2 border">Restaurer</th>
            </tr>
        </thead>
        <tbody>
          {deletedCollaborators.length > 0 ? (
            deletedCollaborators.map((collaborator) => (
              <tr key={collaborator.id}>
                  <td className="p-2 border">{collaborator.name}</td>
                  <td className="p-2 border">{collaborator.email}</td>
                  <td className="p-2 border">{collaborator.jobTitle}</td>
                  <td className="p-2 border">{collaborator.positionJEI}</td>
                  <td className="p-2 border">
                  <ul>
                    {collaborator.projects.map((p) => (
                      <li key={p.id}>{p.projectName}</li>))}
                  </ul>
                  </td>
                <td className="border px-4 py-2">
                  <button
                    onClick={() => handleRestore(collaborator.id)}
                    className="icon-button text-red-600"
                  >
                    <FontAwesomeIcon icon={faUndo} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center p-4" colSpan={6}>
                Aucun collaborator supprimé.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TrashCollaborators;
